import { forwardRef } from 'react';
import { Button as MuiButton, ButtonProps as MUIButtonProps } from '@mui/material';
import useButtonStyles from './useButtonStyles';
import { Color, Variant } from './types';
import { mapToMuiVariant, toMuiColor } from './utils';

type BaseProps = Omit<MUIButtonProps, 'variant' | 'color' | 'classes'>;

type IButtonProps = BaseProps & {
    variant?: Variant;
    color?: Color;
    testid?: string;
};

export const Button = forwardRef<HTMLButtonElement, IButtonProps>(
    ({ variant = 'default', color = 'primary', testid, ...otherProps }, ref) => {
        const classes = useButtonStyles();

        return (
            <MuiButton
                // eslint-disable-next-line react/jsx-props-no-spreading
                {...otherProps}
                ref={ref}
                data-testid={testid}
                variant={mapToMuiVariant(variant)}
                color={toMuiColor(color)}
                classes={{
                    root: classes.root,
                    containedPrimary: classes.containedPrimary,
                    containedSuccess: classes.containedSuccess,
                    containedWarning: classes.containedWarn,
                    containedError: classes.containedError,
                    textPrimary: classes.textPrimary,
                    textError: classes.textError,
                    textSuccess: classes.textSuccess,
                    textWarning: classes.textWarn,
                    outlinedPrimary: classes.outlinedPrimary,
                    outlinedError: classes.outlinedError,
                    outlinedWarning: classes.outlinedWarning,
                    outlinedSuccess: classes.outlinedSuccess,
                }}
            />
        );
    }
);
